/**
 * Dynamic FPS lookup — renders FPS benchmarks from store metafield JSON.
 * Builder: listens for pcb:selection-changed, resolves spec.fps_lookup_key from #pcb-slots.
 * RTS PDP: reads custom.specifications, normalizes CPU/GPU names, matches via nameMap.
 */
(function() {
  'use strict';

  var dataEl = document.getElementById('fps-data');
  if (!dataEl) return;

  var fpsData;
  try { fpsData = JSON.parse(dataEl.textContent); } catch(e) { return; }
  if (!fpsData || !fpsData.lookup) return;

  var container = document.querySelector('[data-fps-dynamic]');
  if (!container) return;

  var slotsEl = document.getElementById('pcb-slots');
  var slots = null;
  if (slotsEl) {
    try { slots = JSON.parse(slotsEl.textContent); } catch(e) {}
  }

  var isBuilder = !!slots;

  // ── Rendering ──────────────────────────────────────────────────────────────

  // Compact format: tuples are [game_handle, fps_1080p, fps_1440p]
  // Game metadata in fpsData.games: { handle: { t: title, img: image_url } }
  var gameMeta = fpsData.games || {};

  // Patch game images from live metaobject data (overrides stale URLs in the JSON metafield)
  var gameImagesEl = document.getElementById('fps-game-images');
  if (gameImagesEl) {
    try {
      var liveImages = JSON.parse(gameImagesEl.textContent);
      Object.keys(liveImages).forEach(function(handle) {
        if (liveImages[handle]) {
          if (!gameMeta[handle]) gameMeta[handle] = {};
          gameMeta[handle].img = liveImages[handle];
        }
      });
    } catch(e) {}
  }

  function renderFps(tuples) {
    if (!tuples || tuples.length === 0) {
      renderEmpty();
      return;
    }

    var resolutions = ['1080p', '1440p'];
    var html = '<div class="pdp-fps-toggle" data-fps-toggle>';

    // Panels
    html += '<div class="pdp-fps-toggle__panels">';
    for (var r = 0; r < resolutions.length; r++) {
      var res = resolutions[r];
      var active = r === 0 ? ' pdp-fps-toggle__panel--active' : '';
      html += '<div class="pdp-fps-toggle__panel' + active + '" data-fps-panel="' + res + '" role="tabpanel">';
      for (var g = 0; g < tuples.length; g++) {
        var tuple = tuples[g];
        var handle = tuple[0];
        var fps = res === '1080p' ? tuple[1] : tuple[2];
        var meta = gameMeta[handle] || {};
        var title = meta.t || handle;
        var imgUrl = meta.img || '';
        // If URL came from image_url filter it already has sizing params; otherwise append them
        var imgSrc = imgUrl ? (imgUrl.indexOf('width=') !== -1 ? imgUrl : imgUrl + (imgUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=180&format=webp') : '';
        html += '<div class="fps-game-row d-flex align-center justify-between">';
        html += '<div class="fps-game-row__left d-flex align-center">';
        if (imgSrc) {
          html += '<img src="' + imgSrc + '" alt="' + escapeHtml(title) + '" class="fps-game-row__img flex-shrink-0" width="166" height="55" loading="lazy">';
        } else {
          html += '<div class="fps-game-row__img fps-game-row__img--placeholder flex-shrink-0"></div>';
        }
        html += '<span class="fps-game-row__name font-secondary color-white text-nowrap">' + escapeHtml(title) + '</span>';
        html += '</div>';
        html += '<div class="fps-game-row__right d-flex align-baseline justify-end flex-shrink-0 text-nowrap color-white">';
        html += '<strong class="fps-game-row__fps-num font-secondary fw-bold">' + fps + '</strong>';
        html += '<span class="fps-game-row__fps-label">FPS</span>';
        html += '</div></div>';
      }
      html += '</div>';
    }
    html += '</div>';

    // Footer
    html += '<div class="pdp-fps-toggle__footer d-flex flex-column align-center gap-10 mt-15">';
    html += '<p class="pdp-fps-toggle__disclaimer text-center mb-0">Estimated Frames Per Second (FPS) Tested on Ultra Settings</p>';
    html += '<div class="fps-tabs__nav" role="tablist"><span class="fps-tabs__slider" aria-hidden="true"></span>';
    for (var t = 0; t < resolutions.length; t++) {
      var sel = t === 0;
      html += '<button class="fps-tabs__btn font-headings fw-semibold' + (sel ? ' fps-tabs__btn--active' : '') + '" role="tab" data-fps-tab="' + resolutions[t] + '" aria-selected="' + sel + '">' + resolutions[t].toUpperCase() + '</button>';
    }
    html += '</div></div></div>';

    container.innerHTML = html;
    container.style.display = '';
    bindTabs(container);
  }

  function renderEmpty() {
    if (isBuilder) {
      container.innerHTML = '<p class="pdp-fps-toggle__empty color-white-muted text-center py-20">Select CPU and GPU to see performance</p>';
      container.style.display = '';
    } else {
      container.innerHTML = '';
      container.style.display = 'none';
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function bindTabs(root) {
    var btns = root.querySelectorAll('[data-fps-tab]');
    var panels = root.querySelectorAll('[data-fps-panel]');
    var slider = root.querySelector('.fps-tabs__slider');

    function moveSlider(btn) {
      if (!slider || !btn) return;
      slider.style.left = btn.offsetLeft + 'px';
      slider.style.width = btn.offsetWidth + 'px';
    }

    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', (function(idx) {
        return function() {
          for (var j = 0; j < btns.length; j++) {
            btns[j].classList.toggle('fps-tabs__btn--active', j === idx);
            btns[j].setAttribute('aria-selected', j === idx ? 'true' : 'false');
          }
          for (var k = 0; k < panels.length; k++) {
            panels[k].classList.toggle('pdp-fps-toggle__panel--active', k === idx);
          }
          moveSlider(btns[idx]);
        };
      })(i));
    }

    // Init slider position on first render
    requestAnimationFrame(function() {
      var activeBtn = root.querySelector('.fps-tabs__btn--active');
      if (slider && activeBtn) {
        slider.style.transition = 'none';
        moveSlider(activeBtn);
        slider.offsetWidth;
        slider.style.transition = '';
      }
    });
  }

  // ── Builder mode ───────────────────────────────────────────────────────────

  function getSpecFromSlots(productHandle, slotType) {
    if (!slots) return null;
    for (var i = 0; i < slots.length; i++) {
      var slot = slots[i];
      if (slot.handle !== slotType) continue;
      var products = slot.products || [];
      for (var p = 0; p < products.length; p++) {
        if (products[p].handle === productHandle) {
          return products[p].spec || null;
        }
      }
    }
    return null;
  }

  function findSlotHandle(suffix) {
    if (!slots) return null;
    for (var i = 0; i < slots.length; i++) {
      var h = slots[i].handle;
      if (h === suffix || h === 'configurator-' + suffix) return h;
    }
    return null;
  }

  var cpuSlotHandle = findSlotHandle('cpu');
  var gpuSlotHandle = findSlotHandle('gpu');

  function findFpsLookupKey(selections) {
    var cpuKey = null, gpuKey = null;

    if (cpuSlotHandle) {
      var cpuSel = selections[cpuSlotHandle];
      if (cpuSel && cpuSel.handle) {
        var cpuSpec = getSpecFromSlots(cpuSel.handle, cpuSlotHandle);
        cpuKey = cpuSpec && cpuSpec.fps_lookup_key || null;
      }
    }

    if (gpuSlotHandle) {
      var gpuSel = selections[gpuSlotHandle];
      if (gpuSel && gpuSel.handle) {
        var gpuSpec = getSpecFromSlots(gpuSel.handle, gpuSlotHandle);
        gpuKey = gpuSpec && gpuSpec.fps_lookup_key || null;
      }
    }

    return { cpuKey: cpuKey, gpuKey: gpuKey };
  }

  if (isBuilder) {
    function renderFromSelections(selections) {
      var keys = findFpsLookupKey(selections);
      if (!keys.cpuKey || !keys.gpuKey) {
        renderEmpty();
        return;
      }
      var comboKey = keys.cpuKey + '|' + keys.gpuKey;
      renderFps(fpsData.lookup[comboKey] || null);
    }

    document.addEventListener('pcb:selection-changed', function(e) {
      renderFromSelections(e.detail || {});
    });

    // The builder dispatches pcb:selection-changed during its synchronous init, but
    // this script is loaded `defer` so we miss that initial event. Pull current
    // selections from the exposed window.PCBuilder API so default-selected CPU+GPU
    // immediately render FPS without waiting for the user to change anything.
    if (window.PCBuilder && window.PCBuilder.selections) {
      renderFromSelections(window.PCBuilder.selections);
    } else {
      renderEmpty();
    }
    return;
  }

  // ── PDP direct-key mode (spec.fps_cpu_key + spec.fps_gpu_key) ─────────────

  var pdpKeysEl = document.getElementById('fps-pdp-keys');
  if (pdpKeysEl) {
    var pdpKeys;
    try { pdpKeys = JSON.parse(pdpKeysEl.textContent); } catch(e) {}
    if (pdpKeys && pdpKeys.cpu && pdpKeys.gpu) {
      renderFps(fpsData.lookup[pdpKeys.cpu + '|' + pdpKeys.gpu] || null);
    } else {
      renderEmpty();
    }
    return;
  }

  // ── RTS PDP mode ───────────────────────────────────────────────────────────

  var specsEl = document.querySelector('[data-rts-specs]');
  if (!specsEl) {
    renderEmpty();
    return;
  }

  var specsRaw;
  try { specsRaw = JSON.parse(specsEl.textContent); } catch(e) { renderEmpty(); return; }
  if (!Array.isArray(specsRaw)) { renderEmpty(); return; }

  var rtsCpu = '', rtsGpu = '';
  for (var s = 0; s < specsRaw.length; s++) {
    var spec = specsRaw[s];
    var lower = spec.toLowerCase();
    if (lower.indexOf('processor:') === 0) rtsCpu = spec.split(':').slice(1).join(':').trim();
    if (lower.indexOf('graphics card:') === 0) rtsGpu = spec.split(':').slice(1).join(':').trim();
  }

  if (!rtsCpu || !rtsGpu) { renderEmpty(); return; }

  // Normalize and match via nameMap
  function normalize(str) {
    var s = str.toLowerCase().replace(/\s+/g, ' ').trim();
    var prefixes = ['amd', 'intel', 'nvidia', 'asus', 'zotac', 'pny', 'gigabyte', 'msi', 'tuf', 'rog', 'asrock', 'evga', 'core', 'ryzen', 'ultra', 'geforce', 'radeon'];
    var changed = true;
    while (changed) {
      changed = false;
      for (var i = 0; i < prefixes.length; i++) {
        if (s.indexOf(prefixes[i] + ' ') === 0) {
          s = s.substring(prefixes[i].length + 1);
          changed = true;
        }
      }
    }
    return s;
  }

  var cpuNorm = normalize(rtsCpu);
  var gpuNorm = normalize(rtsGpu);
  var cpuKey = fpsData.nameMap[cpuNorm];
  var gpuKey = fpsData.nameMap[gpuNorm];

  if (!cpuKey || !gpuKey) { renderEmpty(); return; }

  var comboKey = cpuKey + '|' + gpuKey;
  renderFps(fpsData.lookup[comboKey] || null);

})();
